import { render, staticRenderFns } from "./AffiliateModal.vue?vue&type=template&id=5329a076&"
import script from "./AffiliateModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateModal.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateModal.vue?vue&type=style&index=0&id=5329a076&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports